import React from 'react'
import './publication.css'

function Volume25no12() {
  return (
    <div className="p-2">
      <section className='content-header d-flex flex-column justify-content-start'>
        <h3 className="p-2" >Vol. 25, Nos. 1&2, Mar/Jun 2024</h3>
        <h5 className="p-2">CONTENTS</h5>
            <div className="p-2 contents">
             <a href= '/volume-25-no1&2/MaslowsTheoryandChinuaAchebeEkeKandMukoroE.pdf'><p> Maslow's Theory and Chinua Achebe's Things Fall Apart - 
 <strong>Kola Eke & Edafe Mukoro</strong> - 1 </p> </a> 
              </div>
              <div className="p-2">
            <a href= '/volume-25-no1&2/PragmaticAnalysisofAnnangProverbsSondeSOandMkpangUM.pdf'><p>A Pragmatic Analysis of Annang Proverbs in the Lyrics of Uko Akpa's Songs - 
<strong> Simeon Olufunso Sonde & Usenemem Manaseh Mkpange</strong> - 12 </p></a> 
              </div>
              <div className="p-2">
              <a href= '/volume-25-no1&2/AnalysingCodeSwitchingPracticesUdehJCandUbiVO.pdf'><p>Analyzing Code-Switching Practices in Nigerian Multilingual Marketplace Settings -  
 <strong>Judith Chinedu Udeh & Veronica Onwanyi Ubi</strong> - 30 </p></a>
              </div>
              <div className="p-2">
              <a href= '/volume-25-no1&2/InterpretingPoliticalDiscourseSadiqandSani.pdf'> <p> Interpreting Political Discourse: A Transitivity Analysis of Nigeria's President 
Bola Ahmed Tinubu's Inaugural Speech - 
 <strong> Mohammed T. Sadiq & Habibu Sani</strong> - 46 </p></a>
               </div>
              <div className="p-2">
              <a href= '/volume-25-no1&2/TheCommunicativeRelevanceofKinshipTerms.pdf'><p>The Communicative Relevance of Kinship Terms for Student Mentoring in Southwestern Nigerian Tertiary Institutions -  
 <strong>Vivian Alofe & Mathew Kayode Akano</strong> - 62 </p></a>
              </div>
              <div className="p-2">
              <a href= '/volume-25-no1&2/Pragma-linguisticAnalysisofAdvertisements.pdf'> <p> A Pragma-linguistic Analysis of Textual Features in Some Advertisements by Nigerian Companies on YouTube - 
 <strong> Abosede A. Otemuyiwa & Alice O. Babalola</strong> - 83 </p></a>
               </div>

               <div className="p-2">
              <a href= '/volume-25-no1&2/TowardsaNewParadigmforLanguageTeachingandLearningAkintayoA.pdf'> <p>Towards a New Paradigm for Language Teaching and Learning: Perspectives on Video Conferencing - 
 <strong> Abiodun Akintayo</strong> - 92 </p></a>
               </div>       
            <hr/>

        </section>
    </div>
  )
}

export default Volume25no12;
